var _excluded = ["title", "links"],
  _excluded2 = ["title", "href", "hidden"];
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
import React from 'react';
import { Button } from '@edx/paragon';
var LinkList = function LinkList(_ref) {
  var listTitle = _ref.title,
    _ref$links = _ref.links,
    links = _ref$links === void 0 ? [] : _ref$links,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("div", props, /*#__PURE__*/React.createElement("h2", null, listTitle), /*#__PURE__*/React.createElement("ul", {
    className: "list-unstyled p-0 m-0"
  }, links.map(function (_ref2) {
    var title = _ref2.title,
      href = _ref2.href,
      hidden = _ref2.hidden,
      linkProps = _objectWithoutProperties(_ref2, _excluded2);
    if (hidden) {
      return null;
    }
    if (!href) {
      return /*#__PURE__*/React.createElement("li", {
        key: "".concat(title)
      }, /*#__PURE__*/React.createElement(Button, linkProps, title));
    }
    return /*#__PURE__*/React.createElement("li", _extends({
      key: "".concat(href).concat(title)
    }, linkProps), /*#__PURE__*/React.createElement("a", {
      href: href
    }, title));
  })));
};
LinkList.defaultProps = {
  links: []
};
export default LinkList;